// Custom VFG components

<template>
  <div class="wrapper field-input">
    *** THIS Component not finished - cd ***
    <input
      v-model="value"
      class="form-control"
      type="text"
      :disabled="disabled"
      :maxlength="schema.max"
      :placeholder="schema.placeholder"
      :readonly="schema.readonly"
      @blur=""
    >
  </div>
</template>
 
<script>
    export default {
        props: ['text'],
        name: 'InputFv',
        mixins: [ VueFormGenerator.abstractField],
        methods: {
            // triggerValidation() {
            //     this.validate();
            // }
        }
        ,
        data() {
            return {}
        } }
</script>

<style>
    .wrapper {
        width: 100%
    }
</style>
